import React from 'react'
import {Controller, UseFormMethods} from 'react-hook-form'
import {useCardsTemplate} from 'Event/template/Cards'
import Title from 'lib/ui/ConfigPanel/Title'
import {useAttendeeVariables} from 'Event'
import HTMLEditor, {HTMLEditorContainer} from 'lib/ui/form/HTMLEditor'

export default function Settings(props: {control: UseFormMethods['control']}) {
  const {control} = props
  const {welcomeMessage} = useCardsTemplate()
  const v = useAttendeeVariables()
  return (
    <>
      <Title>Text</Title>
      <HTMLEditorContainer>
        <Controller
          name="text"
          defaultValue={v(welcomeMessage.text)}
          control={control}
          render={({value, onChange}) => (
            <HTMLEditor
              data={value || ''}
              onChange={onChange}
              aria-label="dashboard welcome text"
            />
          )}
        />
      </HTMLEditorContainer>
    </>
  )
}
